import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="sendmail">
                1.&nbsp;<span className="material-symbols-outlined">send</span>&nbsp;{translate('sendmail')}
            </Typography>
            <p><strong>{translate('sendmail')}</strong> は、Google mail API を使用してメールを送信するアクションです。この機能により、ユーザーは Google mail アカウントから電子メールを送信できるようになります。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Google mailメール アカウントを識別するために使用される<strong>Provider ID</strong>  (接続方法は、<Box component={Link} to="/control-center/documentation/connections/gmail">こちら</Box>をご確認ください。)</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('from')}</td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>送信者のアドレス。 Google mailの設定からアカウントに追加されたアドレスを使用できます (追加方法は、 <a href='https://support.google.com/mail/answer/22370' target="_blank">こちら</a> をご確認ください。)</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('to')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>受信先</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('subject')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>メールのタイトル</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('body')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>メールの内容</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('attachments')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>メールに添付するファイルのパスです。複数のファイル (カンマ区切りのパス) を指定することもできます。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('cc')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the sending address in CC. You can also specify multiple addresses and named addresses.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('bcc')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>CCの送信アドレス。複数のアドレスと名前付きアドレスを指定することもできます。</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gmail-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('to')}</span>
                            <div>john.doe@example.com</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('subject')}</span>
                            <div>Hello! John!</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('body')}</span>
                            <div>こんにちは、太郎さん！お元気ですか</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getgmail">
                2.&nbsp;<span className="material-symbols-outlined">mark_email_unread</span>&nbsp;{translate('getgmail')}
            </Typography>
            <p><strong>{translate('getgmail')}</strong> は、Google Workspace アカウントの Google mail からメールを取得するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>取得メールの保存先</td>
                                <td>$gmailMessages_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Google mailメール アカウントを識別するために使用される<strong>Provider ID</strong>  (接続方法は、<Box component={Link} to="/control-center/documentation/connections/gmail">こちら</Box>をご確認ください。)</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('query')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>検索条件 (確認方法は、 <a href='https://support.google.com/mail/answer/7190' target="_blank">こちら</a> をご確認ください。 )</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('limit')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>取得される電子メールの最大数</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('markasread')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>メッセージを既読としてマークするアクションとして、もし <strong>{translate('markasread')}</strong> 有効(true)になったら, 検索条件に応じたメールを確認後、既読になります。</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$gmailMessages_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gmail-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('query')}</span>
                            <div>from: john.doe@example.com</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('markasread')}</span>
                            <div>true</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            {
                                                "id": "123456789abcdefg",
                                                "subject": "Hello! Me!",
                                                "to": "me <me@gmail.com>",
                                                "cc": "aaa <aaa@gmail.com>",
                                                "from": "bbb <bbb@gmail.com>",
                                                "date": "2023-01-14T10:41:09.000Z",
                                                "body": "Nice to meet you!",
                                                "html": "",
                                                "attachements": [
                                                {
                                                    "filename": "combine.pdf",
                                                    "contentType": "application/octet-stream",
                                                    "attachmentId": "ANGjdJ8xf--nLYOiblQaphB0PPmxwiHzqWb189HnjTBSsfYaIEDtgYj2ERCLNrDwMw_okMmC6yPCsip0rHRTvzwH7PbjuEd7TPE1mkYHPANdMCd0K8BU9kNEwR0AEKfw8JFPuHlxcTznvBBVlyjXfdMdjtrRSYRKPKwD-sqRZL0mleYM5TARSDLLKFVl0rhlMNFhvnFwUCLQPx_EmrHByTu2iZOQqDFLwF2gPuAvsvz3qc_ZmrCMs6A825NfRcniz0AzcNvDaCEEAMjbrif6hzOVqnaT1wBeBw-uRX9KxiFLquwuxW3-GI6oRROSG5QdzuzuvCUzcaK4vqxCaGzcDil0OjOOgbYBKCEZMXjKpGfeSq416VpQcj4t3YCaO0c8mfjP7MbwkHxmAS7wT8kGUSMI_0icEtmHKuQNwy3dgQ"
                                                },
                                                {
                                                    "filename": "image.png",
                                                    "contentType": "image/png",
                                                    "attachmentId": "ANGjdJ9A5SjcD6C0B3vB-DKy5bt7b8FxTPJpnAVwJ7KmtZ3bPRH8vYyM8XbWqUbNGLvGveHo0f4B0ucUiyTTV1zLRRQigFPTTHtdxE4rZodBQQjvQng3Fnyv82Z8H7rlyA2ST8eXP4sEvaWuJy16Gs8qS_QNVME86VLkSllif19xEwddOK3fM2WXmCG8A8kGdOl1W8xHpJ44wAVgzjxn1ah2VbxKbS-HEjx9n-kZ70rtlIKBlRl-5Nhr2MrifV4LtTvSx6Z-14Iw7RmECkB4PC6fHQk7CseD3z6x3aa4oRDygNeAwakSHbYq-FFajw1elYkCfG6b6t8sIEslCvNHERw8J3JiQfdcWE6QSoXkCSsp56xrkAsS4W__iQQ3hxR1iehbMu_h1rPTw4oANJ3R"
                                                }
                                                ]
                                            }
                                        ], null, 2)}
                                </pre>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="gmaildownloadattachments">
                3.&nbsp;<span className="material-symbols-outlined">attach_email</span>&nbsp;{translate('gmaildownloadattachments')}
            </Typography>
            <p><strong>{translate('gmaildownloadattachments')}</strong>これは、<strong>{translate('getgmail')}</strong> の結果に含まれるすべてのファイルをダウンロードするアクションです (ダウンロードはストレージに保存されます)。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ダウンロードファイルの保存先</td>
                                <td>$gmailAttachments_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Google mailメール アカウントを識別するために使用される<strong>Provider ID</strong>  (接続方法は、<Box component={Link} to="/control-center/documentation/connections/gmail">こちら</Box>をご確認ください。)</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('gmailmessages')}<span>*</span></td>
                                <td>
                                    <div className='type-value'>
                                        <span className="material-symbols-outlined">data_array</span>
                                        <span>{translate('datatype__array')}</span>
                                    </div>
                                </td>
                                <td><strong>{translate('getgmail')}</strong>結果</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$gmailAttachments_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gmail-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('gmailmessages')}</span>
                            <div>$gmailMessages_1</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "/tmp/downloads/sktwi174l9kzzqc2/20221025-003483/combine.pdf",
                                            "/tmp/downloads/sktwi174l9kzzqc2/20221025-003483/image.png",
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(En);